import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';


const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const UPDATE_COLUMNS_RATIO = `${NAMESPACE}/UPDATE_COLUMNS_RATIO`;
export const VIDEO_PLAYER_MOUNTED = `${NAMESPACE}/VIDEO_PLAYER_MOUNTED`;
export const UPDATE_COMMANDS_FILTER = `${NAMESPACE}/UPDATE_COMMANDS_FILTER`;
export const APPEND_NOTIFICATION = `${NAMESPACE}/APPEND_NOTIFICATION`;
export const SET_GALLERY_FULL_SCREEN = `${NAMESPACE}/SET_GALLERY_FULL_SCREEN`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
export const REPORT_JOB_ISSUE = createApiNamespacedConstants('REPORT_JOB_ISSUE');
